const entityType = [
  'PT',
  'CV',
  'Personal'
]

export default entityType
